import CookiesWarning from "./cookiesWarning";

export default CookiesWarning;
